import * as t from 'io-ts'

//todo Awaited will be baked in with ts 4.5, on 4.4 as of writing
export type Awaited<T> = T extends PromiseLike<infer U> ? U : T

export const PlaylistCodec = t.intersection([
  t.type({
    id: t.string,
    name: t.string
  }),
  t.partial({
    snapshot_id: t.string,
    last_updated: t.string,
    added_by: t.string
  })
])

export const InteractionsCodec = t.type({
  saved: t.array(t.string),
  votes: t.array(t.string)
})

export type Playlist = t.TypeOf<typeof PlaylistCodec>
export type Interactions = t.TypeOf<typeof InteractionsCodec>
